export default __webpack_public_path__ + "static/media/volkswagen.4181db67.svg";